<div *ngIf="selectedBanner" class="container">
  <div class="top-banner">
    <a class="cursor-pointer" (click)="navigation(selectedBanner.url)">
      <img class="d-none d-md-block d-lg-block" [src]="selectedBanner.file.versions[3]" [alt]="selectedBanner.title" />
    </a>
  </div>
</div>
